/* eslint-disable consistent-return */
import {
  useEffect, useRef, useCallback,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import maplibregl from 'maplibre-gl';
import { toast } from 'react-toastify';
import { setLocationCoordinates, setAddress } from '@library/MaplibreMap/maplibre-map.slice';
import { isPointWithinMalawi } from '@library/MaplibreMap/maplibre-map.utils';
import { getReverseGeocodeData } from '@services/data.service';
import { useNetworkState } from '@services/hooks.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';

function NewLocationMarker() {
  const map = useSelector(state => state.maplibremap.map);
  const { t } = useTranslation();
  const markerRef = useRef(null);
  const dispatch = useDispatch()
  const locationCoordinates = useSelector(state => state.maplibremap.locationCoordinates);

  const isOnline = useNetworkState();

  // Cleanup function to remove marker
  const removeMarker = useCallback(() => {
    if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
  }, []);

  // Effect for handling location changes
  useEffect(() => {
    if (locationCoordinates.lat === null || locationCoordinates.lng === null) {
      return;
    }

    const locationSelectedBySearch = (lat, lng) => {
      const newMarker = new maplibregl.Marker({ color: '#72A276' })
        .setLngLat([lng, lat])
        .addTo(map);
      
      markerRef.current = newMarker;
    };
    
    locationSelectedBySearch(locationCoordinates.lat, locationCoordinates.lng);

    return removeMarker;
  }, [dispatch, locationCoordinates, map, removeMarker]);

  useEffect(() => {
    if (!map) return;
    
    const handleMapClick = async (e) => {
      const { lng, lat } = e.lngLat;

      const isWithinMalawi = await isPointWithinMalawi(lat, lng);

      if (!isWithinMalawi) {
        toast.error(t('Please choose a location in Malawi.'));
        return;
      }

      dispatch(setLocationCoordinates({ lat, lng }));

      map.flyTo({
        center: [lng, lat],
        zoom: 12,
      });
  
      if (!isOnline) {
        dispatch(setAddress(''));
      }
    };

    map.on('click', handleMapClick);

    return () => {
      if (map && !map._removed) {
        map.off('click', handleMapClick);
      }
    };
  }, [map, dispatch, isOnline, t]);

  useEffect(() => {
    if (isOnline && locationCoordinates.lat !== null && locationCoordinates.lng !== null) {
      getReverseGeocodeData(locationCoordinates.lat, locationCoordinates.lng)
        .then(result => dispatch(setAddress(result.split(' ').slice(1).join(' '))));
    }
  }, [locationCoordinates, dispatch, isOnline]);

  return null
}

export default NewLocationMarker